/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Categoryindex_Description1Inputs */

const en_seo_categoryindex_description1 = /** @type {(inputs: Seo_Categoryindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse AI tools by category and discover curated collections of AI products.`)
};

const zh_seo_categoryindex_description1 = /** @type {(inputs: Seo_Categoryindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按分类浏览 AI 工具，发现精选的 AI 产品合集。`)
};

/**
* | output |
* | --- |
* | "Browse AI tools by category and discover curated collections of AI products." |
*
* @param {Seo_Categoryindex_Description1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const seo_categoryindex_description1 = /** @type {((inputs?: Seo_Categoryindex_Description1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Categoryindex_Description1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seo_categoryindex_description1(inputs)
	return zh_seo_categoryindex_description1(inputs)
});
export { seo_categoryindex_description1 as "seo.categoryIndex.description" }